<template>
  <div>
    <div>
      <span class="text-h6 black--text">Psoríase</span>

      <text-area :value="attendanceHypothesis" auto-grow readonly hide-details class="hypothesis" />

      <div class="d-flex flex-column grey--text text--darken-1 font-weight-bold mt-6">
        <p>
          Esse fluxo foi criado para auxiliar na avaliação e conduta de casos com suspeita de psoríase.<br />
          Clique no menu à direita em <v-icon color="primary">mdi-human-greeting-proximity</v-icon> (INTERCONSULTA) para
          discutir o seu caso com um EXPERT.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import TextArea from '@/components/TextArea.vue'

import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

export default {
  extends: BasePhase,
  components: {
    TextArea,
  },
  computed: {
    ...attendanceGettersMap(['attendanceHypothesis']),
  },
  methods: {
    getDefaultData() {
      return null
    },
  },
}
</script>

<style scoped></style>
